/**
 * The below file is the Storm Non Inmates Registration service which contains method for doing the API calls.
 * @author: vishal.mishra@velsof.com
 * @date : 01-04-2024
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Storm_Create_Non_Inmates_Registration,
  Storm_Export_Non_Inmates_Registration,
  Storm_Import_Non_Inmates_Registration,
  Multipart_Form_Data,
  Blob,
  Storm_Import_Non_Inmates_Registration_Xlsx,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const StormNonInmatesRegistrationServices = {};

//#region Method for Storm Freeze Report listing page.

/**
 * Method for getting the Storm Freeze Report listing
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.getAll = function (param) {
  return fetch({
    url: Storm_Create_Non_Inmates_Registration,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    params: param,
  });
};

//#region Method for Storm Freeze Report .

/**
 * Method for importing the Storm Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.create = function (data) {
  return fetch({
    url: Storm_Create_Non_Inmates_Registration,
    method: "post",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Storm Freeze Report .

/**
 * Method for importing the Storm Freeze Report
 * @param {any} data API Data
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.update = function (data, id) {
  return fetch({
    url: Storm_Create_Non_Inmates_Registration + `/${id}`,
    method: "put",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    data: data,
  });
};

//#endregion Method for Storm Freeze Report .

/**
 * Method for importing the Non Camp Inmates Registration
 * @param {any} data API data
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.nonCampInmatesRegistrationImport =
  function (data) {
    return fetch({
      url: Storm_Import_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for importing the Non Camp Inmates Registration Excel
 * @param {any} data API data
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.nonCampInmatesRegistrationImportExcel =
  function (data) {
    return fetch({
      url: Storm_Import_Non_Inmates_Registration_Xlsx,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: data,
    });
  };

/**
 * Method for getting the Non Camp Inmates Registration export data
 * @returns Fetch Method
 */
StormNonInmatesRegistrationServices.getExportNonInmatesRegistrationData =
  function (payload) {
    return fetch({
      url: Storm_Export_Non_Inmates_Registration,
      method: "post",
      headers: {
        "Content-Type": Application_Json,
        Authorization: format(
          Authorization_Token,
          localStorage.getItem(AUTH_TOKEN)
        ),
      },
      data: payload,
      responseType: Blob,
    });
  };

export default StormNonInmatesRegistrationServices;
